import React from 'react';
import { Row, Col, Label } from "reactstrap";
import { Link } from "react-router-dom";

export default class ContainersDetalhesDadosGerais extends React.Component {

    constructor(props) {
        super(props);
    }
    
    render() {
        return (
            <div className="containers-detalhes">
                <h2>Dados Gerais</h2>
                <Row>
                    <Col xs={6} sm={4} className="containers-detalhes-col">
                        <Row>
                            <Col>
                                <Label className="label-disabled">ARMADOR</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label className="label-secondary">{ this.props.dadosContainer.Armador ? this.props.dadosContainer.Armador : "---" }</Label>
                            </Col>
                        </Row>
                    </Col>
                    {this.props.dadosContainer.Categoria === "EXPORTAÇÃO" && <Col xs={6} sm={4} className="containers-detalhes-col">
                        <Row>
                            <Col>
                                <Label className="label-disabled">BOOKING</Label> 
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Link className="link" to={{
                                            pathname: '/booking',
                                            state: {
                                                    codigoBooking: this.props.dadosContainer.BookingNbr,
                                                    codigoContainer: this.props.dadosContainer.Cntr,
                                                    container: this.props.filtros.container,
                                                    booking: this.props.filtros.booking,
                                                    notaFiscal: this.props.filtros.notaFiscal
                                                }
                                            }}>
                                    <Label><a href="/#">{ this.props.dadosContainer.BookingNbr ? this.props.dadosContainer.BookingNbr : "---" }</a></Label>
                                </Link> 
                            </Col>
                        </Row>
                    </Col>}
                    <Col xs={6} sm={4} className="containers-detalhes-col">
                        <Row>
                            <Col>
                                <Label className="label-disabled">PESO MÁXIMO</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label className="label-secondary">{ this.props.dadosContainer.PesoMaximo ? this.props.dadosContainer.PesoMaximo : "---" }</Label>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={6} sm={4} className="containers-detalhes-col">
                        <Row>
                            <Col>
                                <Label className="label-disabled">TIPO / TAM</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label className="label-secondary">{ this.props.dadosContainer.Tipo ? this.props.dadosContainer.Tipo : "---" }</Label>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={6} sm={4} className="containers-detalhes-col">
                        <Row>
                            <Col>
                                <Label className="label-disabled">ISO</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label className="label-secondary">{ this.props.dadosContainer.Iso ? this.props.dadosContainer.Iso : "---" }</Label>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={6} sm={4} className="containers-detalhes-col">
                        <Row>
                            <Col>
                                <Label className="label-disabled">TARA</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label className="label-secondary">{ this.props.dadosContainer.Tara ? this.props.dadosContainer.Tara : "---" }</Label>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/consultas/containers/components/ContainersDetalhesDadosGerais.js